export default __webpack_public_path__ + "static/media/m-satsivi.fbf1a41b.png";